<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="hotel && hotel.id"
      >{{ 'HOTEL.HOTEL_FORM.EDIT' | translate }}

      <small *ngIf="hotel && form?.get('gallery_count')?.value">
        {{ 'HOTEL.HOTEL_FORM.IMAGES_COUNT' | translate }}: {{ form.get('gallery_count').value }}
      </small>
    </span>
    <span *ngIf="!hotel || !hotel.id">{{ 'HOTEL.HOTEL_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="hotel-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-2">
        <app-image-input [form]="form" controlName="logo" newControlName="new_logo"></app-image-input>
      </div>
      <div class="col-sm-10">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="name" />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.TYPE' | translate }}</label>
              <app-type-select
                [parentFormGroup]="form"
                [passFormControlName]="'type_id'"
                [groupType]="'hotels'"
              ></app-type-select>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.STARS' | translate }}</label>
              <select class="form-control" formControlName="stars">
                <option [ngValue]="null">{{ 'HOTEL.HOTEL_FORM.WITHOUT_STARS' | translate }}</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.ROOMS' | translate }}</label>
              <input type="number" class="form-control" formControlName="rooms_count" />
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.VAT_NUMBER' | translate }}</label>
              <input type="text" class="form-control" formControlName="vat_number" />
            </div>
          </div>

          <div class="col-sm-12">
            <app-tags-select [parentFormGroup]="form" [model]="LaravelModelsEnum.HOTEL"></app-tags-select>
          </div>

          <div class="col-sm-12">
            <app-bank-data [parentFormGroup]="form" [single]="true"></app-bank-data>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <app-contact #contactComp [parentFormGroup]="form" [showNote]="true"></app-contact>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row justify-content-between">
          <div class="col-auto">
            <div class="modal-section-title mb-2">
              {{ 'HOTEL.HOTEL_FORM.LOCATION' | translate }}
            </div>
          </div>
          <div class="col-auto" *ngIf="form && form.get('lat').value && form.get('long').value">
            <a
              href="https://www.google.com/maps/dir//{{ form.get('lat').value }},{{ form.get('long').value }}/@{{
                form.get('lat').value
              }},{{ form.get('long').value }},10z?hl=en-US"
              target="_blank"
            >
              {{ 'HOTEL.HOTEL_FORM.DIRECTIONS' | translate }}
            </a>
          </div>
        </div>
        <google-map
          *ngIf="form && form.get('lat').value && form.get('long').value"
          class="agm-map"
          height="200px"
          [center]="{
            lat: number(this.form.get('lat').value),
            lng: number(this.form.get('long').value),}
          ">
          <map-marker
            [position]="{
            lat: number(this.form.get('lat').value),
            lng: number(this.form.get('long').value),}
            "
            [title]="this.form.value.name"
            [options]="{draggable: true }"
            (mapDragend)="selectLocation($event)"
          >
          </map-marker>
        </google-map>
        <div class="map-placeholder" *ngIf="!form?.get('lat')?.value || !form?.get('long')?.value"></div>

        <div class="row">
          <div class="col-sm-6">
            <app-cities-select
              [parentFormGroup]="form"
              [fillParentFormCoordinates]="true"
              #citySelect
            ></app-cities-select>
          </div>
          <div class="col-sm-6">
            <label>{{ 'HOTEL.HOTEL_FORM.ADDRESS' | translate }}</label>
            <app-google-places-autocomplete (placeSelected)="handleAddressChange($event)"
                                            [initialValue]="form.get('address').value"
                                            [countryCode]="countryCode"
            ></app-google-places-autocomplete>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.LAT' | translate }}</label>
              <input type="number" class="form-control" formControlName="lat" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.LONG' | translate }}</label>
              <input type="number" class="form-control" formControlName="long" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.CENTER' | translate }}</label>
              <input type="number" class="form-control" formControlName="distance_to_center" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.AIRPORT' | translate }}</label>
              <input type="number" class="form-control" formControlName="distance_to_airport" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.TR_POINT_NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="distance_to_tr_point_name" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'HOTEL.HOTEL_FORM.TR_POINT_DISTANCE' | translate }}</label>
              <input type="number" class="form-control" formControlName="distance_to_tr_point" />
            </div>
          </div>
        </div>

        <app-venue-distance
          [parentFormGroup]="form"
          [distance]="{
            lat: form.get('lat').value,
            long: form.get('long').value
          }"
        ></app-venue-distance>
      </div>
      <div class="col-sm-6">
        <app-contact-person [parentFormGroup]="form" [withEvent]="true" [cols]="6" [showNote]="true"></app-contact-person>
      </div>
    </div>

    <hr class="mb-2" />
    <div class="row" formArrayName="facilities">
      <div class="col-sm-12">
        <div class="modal-section-title mb-1">{{ 'HOTEL.HOTEL_FORM.FACILITIES' | translate }}</div>
      </div>
      <div class="col-sm-6" *ngFor="let facility of form.get('facilities')?.controls; let i = index">
        <div class="form-group" [formGroupName]="i">
          <label>{{ facility.get('name').value }}</label>
          <textarea
            class="form-control facility-description-textarea"
            formControlName="description"
            pInputTextarea
            autoResize="true"
          ></textarea>
        </div>
      </div>
    </div>

    <hr class="mb-2" />

    <div class="row">
      <div class="col-sm-12">
        <div class="modal-section-title mb-1">{{ 'HOTEL.HOTEL_FORM.NOTE' | translate }}</div>
        <div class="form-group">
          <textarea
            class="form-control facility-description-textarea"
            formControlName="note"
            pInputTextarea
            autoResize="true"
          ></textarea>
        </div>
      </div>

      <div class="col-sm-1">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input type="checkbox" class="custom-control-input" formControlName="active" id="hotel-form-active" />
          <label class="custom-control-label" for="hotel-form-active">
            {{ 'HOTEL.HOTEL_FORM.ACTIVE' | translate }}</label
          >
        </div>
      </div>

      <div class="col-sm-2">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input
            type="checkbox"
            class="custom-control-input"
            formControlName="show_to_web"
            id="hotel-form-show-to-web"
          />
          <label class="custom-control-label" for="hotel-form-show-to-web">
            {{ 'HOTEL.HOTEL_FORM.SHOW_TO_WEB' | translate }}</label
          >
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer d-flex justify-content-between">
  <div>
    <app-links-compact-translates [data]="hotel"></app-links-compact-translates>
  </div>
  <div>
    <button type="submit" class="btn btn-outline-dark btn-xs" form="hotel-form" [disabled]="form.invalid" [class.disabled]="form.invalid">
      {{ 'HOTEL.HOTEL_FORM.SAVE' | translate }}
    </button>
  </div>
</div>
